import {observable, action} from "mobx";

class WinPageStore {
    @observable couponCode = null;
    @observable title = null;
    @observable buttonLabel = null;
    @observable text = null;
    @observable couponCodeTitle = null;

    @action
    getDataFromJson(json) {
        this.couponCode = json.coupon_code;
        this.title = json.title;
        this.text = json.win_page_text;
        this.couponCodeTitle = json.coupon_code_title;
        this.buttonLabel = json.button_label;
    }


}

const winPageStore = new WinPageStore();
export default winPageStore;